import baguetteBox from 'baguettebox.js';

export default function () {
	const imageGallery = document.querySelector('.c-gallery');
	const imagesWithZoom = document.querySelectorAll('.c-imagewithzoom');
	const mediaQuery = '(min-width: 768px)';
	const mediaQueryList = window.matchMedia(mediaQuery);

	function setImageGallery() {
		if (imageGallery != null) {
			baguetteBox.run('.c-gallery', {
				buttons: true,
				captions: false
			});
		}
	}

	function setImageWithZoom() {
		if (mediaQueryList.matches) {
			baguetteBox.run('.c-imagewithzoom', {
				buttons: false,
				captions: false
			});
		} else {
			baguetteBox.destroy('.c-imagewithzoom');
			setImageGallery();
		}
	};
	
	setImageGallery();

	if (imagesWithZoom) {
		mediaQueryList.addEventListener('change', event => {
			setImageWithZoom();
		});
		setImageWithZoom();
	}
}
